import { render } from "./VButtonIcon.vue?vue&type=template&id=87d6599e"
import script from "./VButtonIcon.vue?vue&type=script&lang=js"
export * from "./VButtonIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__